module.exports = __webpack_public_path__ + "img/2ar.3ded310e.png";